import AttendeeReviewForm from './AttendeeReviewForm';
import { connect } from 'react-redux';
import { get } from 'lodash';

export function mapStateToProps (state, { reviewId }) {
  const review = get(state, `reviews[${reviewId}]`);
  return {
    accessToken: get(state, 'auth.accessToken'),
    review,
    listingId: get(review, 'listing._id'),
    initialValues: {
      reviewer_type: 'attendee'
    }
  };
}

const AttendeeReviewFormC = connect(mapStateToProps)(AttendeeReviewForm);

export default AttendeeReviewFormC;
